// модуль для формирования ссылки на родительскую рубрику в листинге акций

app.modules.rubricators = (function (self) {
  function _init() {
    if (!location.pathname.includes('/deals')) return;

    _setParentRubricLink();
  }

  function _setParentRubricLink() {
    const breadcrumbs = document.querySelector('.breadcrumbs');
    const parentRubricLink = document.querySelector(
      '.js-rubricators-root-rubric'
    );

    if (!breadcrumbs || !parentRubricLink) return;

    const breadcrumbsLinks = breadcrumbs.querySelectorAll('a');
    const lastBreadcrumb = breadcrumbsLinks[breadcrumbsLinks.length - 1];

    parentRubricLink.textContent = lastBreadcrumb.textContent.trim();
    parentRubricLink.href = lastBreadcrumb.href;
  }

  self.load = _init;
  return self;
})(app.modules.rubricators || {});
